import React from 'react'

import {
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";

const AlertTable = ({ riskAssessmentData }) => {
  if (riskAssessmentData) {
    return (
      <div>
        <TableContainer component={Paper} variant="outlined">
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>
                  <strong>Note</strong>
                </TableCell>
                <TableCell>
                  <strong>Risk Level</strong>
                </TableCell>
                <TableCell>
                  <strong>Complication Area</strong>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {riskAssessmentData.map((item, idx) => {
                // Determine background color based on risk level
                const level = item["Risk Level"];
                let bgColor = "";
                if (level === "High") bgColor = "#f8d7da"; // light red
                else if (level === "Moderate")
                  bgColor = "#fff3cd"; // light yellow
                else if (level === "Low") bgColor = "#d4edda"; // light green

                return (
                  <TableRow key={idx} hover sx={{ backgroundColor: bgColor }}>
                    <TableCell>
                      <h6>{item.Notes}</h6>
                    </TableCell>
                    <TableCell>
                      <h6>{level}</h6>
                    </TableCell>
                    <TableCell>
                      <h6>{item["Complication Area"]}</h6>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    )
  }
  return (
    <div className="flex items-center h-full">
      <h5>No Risk Found</h5>
    </div>
  );
}

export default AlertTable;